import { Helmet } from "react-helmet-async";

const SITE_NAME = "GESIL — Global e-Village Services India Ltd";
const DEFAULT_DESC =
  "GESIL is a leading GovTech, AI and eGovernance solutions company in India delivering digital transformation for government departments, PSUs and smart cities.";
const PUBLIC_URL =
  process.env.REACT_APP_BACKEND_URL || "https://gesil.co.in";

export default function Seo({
  title,
  description = DEFAULT_DESC,
  image,
  type = "website",
  path = "",
}) {
  const fullTitle = title ? `${title} · GESIL` : SITE_NAME;
  const url = `${PUBLIC_URL}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}
      <meta name="keywords" content="GovTech India, eGovernance Solutions, Government Technology Company, AI for Government, Municipal Revenue Management, GST Analytics Platform, Government AI Platform, Digital Governance Solutions, State Government IT Solutions, Citizen Service Delivery Platform, UniDAF, GESIL" />
      <meta name="theme-color" content="#0A1128" />
    </Helmet>
  );
}
